import { styled } from "@mui/material"

export const StyledLoginForm = styled("form")({
	display: "grid", rowGap: "20px"
})